/**
 * @author varun
 */
angular.module('AppCtrl.select2.service', [])
// factory just executes the function and returns the result.
.factory('jvformatResult', function () {
	return function (state) {
		if (state.constructor == Object) {
			return state.fullName;
		}
		return '';
	};
})
//assigns a constant or an object literal to the service.
.value('jvformatSelection', function (state) {
	if (state.constructor == Object) {
		return state.fullName;
	} else if (state) {
		return state;
	}
	return '';
})
// service just executes the function and for the returning function puts a new in front.
.factory('jvid', function () {
	return function (state) {
		if (state.constructor == Object) {
			return state.EId;
		}
		return 0;
	};
})
// service when the user changes the model directly instead of changing it from the ui, In that case the directive asks this service to return the object that needs to be rendered here.
.factory('returnObjectForId', ['tasksService', '$http', function (tasksService) {
	/**
	 * @param {Object} eid: the identifier for which the select 2 option needs to find the object.
	 * @param {Object} callback: what needs to be called after we find the object.
	 */
	var callAlreadySent = {};
	return function (eid, callback) {
		//if( tasksService.selfObject.eid == eid){
		if (angular.isDefined(tasksService.userMapper) && angular.isDefined(tasksService.userMapper[eid])) {
			callback(tasksService.userMapper[eid]);
		} else {
			//Don't need this as everything comes from the backend now.
		}
	};
}])
.factory('massageRequestForSaving', function () {
	return function (entityCopy) {
		//Remove the null/undefined values.
		for (var k in entityCopy) {
			if (typeof entityCopy[k] == 'undefined' || entityCopy[k] == null) {
				delete entityCopy[k];
			}
		}

		// status understands only 'Open' and 'Complete'
		if (entityCopy['type'] == 1) {
			entityCopy['status'] = 'Open';
		} else {
			entityCopy['status'] = 'Complete';
		}

		// Remove these values.
		var key = ['typecheckbox', 'id', 'updateDate', 'completionDate', 'createDate', 'entityId', 'incompleteReminderDate', 'overdueReminderDate', 'ownerId', 'userId', 'companyId', 'duplicateOwnerEId', 'ellipseContent', 'class', 'assignToSomeone', '$$hashKey'];
		for (var i = 0, j = key.length; i < j; i++) {
			if (typeof entityCopy[key[i]] != 'undefined') {
				delete entityCopy[key[i]];
			}
		}
		// Updating dueDate format to 'MM/DD/YYYY'
		if (entityCopy['dueDate'] != 'undefined') {
			entityCopy['dueDate'] = moment(entityCopy['dueDate']).format('MM/DD/YYYY');
		}
		return entityCopy;
	};
});